import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';

/**
 * This function is used to find if an element is a react element
 * @param {String|null|ReactElement} element
 * @returns if element is a react element
 */
function isReactElement(element) {
  return typeof element === 'function' && /*#__PURE__*/React.isValidElement(element({}));
}

/**
 * Function to setIcon to default to one of the icon components rather than the Icon component
 * @param {ReactElement} Icon - React Icon Component
 * @param {String|null|ReactElement} iconProp
 * @param {Object} iconProps - properties passed to returned component
 * @param {ReactElement} additionalIcon - optional when component expects an icon component
 * @returns iconElement
 */
function setIcon(Icon, iconProp, iconProps, additionalIcon) {
  let iconElement = null;
  if (isReactElement(iconProp)) {
    const IconReactElement = iconProp;
    iconElement = /*#__PURE__*/React.createElement(IconReactElement, iconProps);
  } else if (iconProp === true) {
    iconElement = additionalIcon(iconProps);
  } else if (typeof iconProp === 'string') {
    // can add a console.warn here when we have new icons in the index.js
    iconElement = /*#__PURE__*/React.createElement(Icon, _extends({
      type: iconProp
    }, iconProps));
  }
  return iconElement;
}
setIcon.propTypes = {
  iconProp: PropTypes.oneOf([PropTypes.string, PropTypes.func]),
  iconProps: PropTypes.any,
  additionalIcon: PropTypes.func
};
setIcon.defaultProps = {
  Icon: null,
  iconProp: null,
  iconProps: {},
  additionalIcon: null
};

export { setIcon as s };
